import { Container } from "./styles";

export const MainContainer = ({ children }) => {
    
        return (
            <Container>
                {children}
            </Container>
        )
    }